import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import type { OnboardingCurve as OnboardingCurveData } from '@/types';
import { OnboardingCurveChart } from './OnboardingCurveChart';

export function OnboardingCurve({ curve }: { curve: OnboardingCurveData }) {
  if (curve.currentEvent.points.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Onboarding Pace</CardTitle>
        <CardDescription>
          Cumulative share of invited hackers that completed onboarding, by
          hours elapsed since the first onboarding of each edition. Toggle past
          editions to compare pace.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <OnboardingCurveChart data={curve} />
      </CardContent>
    </Card>
  );
}
